import { render, staticRenderFns } from "./PersonVisitViewPanel.vue?vue&type=template&id=0a629e20"
import script from "./PersonVisitViewPanel.vue?vue&type=script&lang=js"
export * from "./PersonVisitViewPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports